import { clsx } from 'clsx';
import { HiArrowTopRightOnSquare } from 'react-icons/hi2';
import { useUi } from '../../provider/UiContext';
import './TraceJournalLink.scss';

export interface ITraceJournalLinkProps {
    /** Код обращения */
    traceId: string;
    className?: string;
}

/**
 * «В журнал» рядом с кодом обращения: журнал ошибок админки, отфильтрованный по коду. Адрес и право на него —
 * забота приложения (`UiProvider.traceJournalHref`); без адреса ссылки нет. В строке таблицы — не ссылка строки:
 * пунктов «Открыть в новой вкладке» контекстного меню она не даёт.
 */
const TraceJournalLink = ({ traceId, className }: ITraceJournalLinkProps) => {
    const href = useUi().traceJournalHref?.(traceId);
    if (!href) return null;
    return (
        <a
            className={clsx('rf-trace-journal-link', className)}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            data-row-link="false"
            title="Открыть журнал ошибок в админке с фильтром по коду обращения"
        >
            В журнал
            <HiArrowTopRightOnSquare aria-hidden />
        </a>
    );
};

export default TraceJournalLink;
